module.exports = __webpack_public_path__ + "assets/fonts/Roboto-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/Roboto-Regular.woff2
// module id = 690
// module chunks = 0